import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const TOKEN_KEY = "gf_admin_token";

export const mediaUrl = (u) => {
  if (!u) return "";
  return u.startsWith("/api") ? `${BACKEND}${u}` : u;
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "America/New_York",
    });
  } catch {
    return "";
  }
}

// Quarter label on an Oct-start fiscal calendar (Jul-Sep = Q4 of that year).
export function formatQuarter(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const m = d.getMonth(); // 0-11
    let q, year;
    if (m >= 9) { q = 1; year = d.getFullYear() + 1; }       // Oct-Dec
    else if (m >= 6) { q = 4; year = d.getFullYear(); }       // Jul-Sep
    else if (m >= 3) { q = 3; year = d.getFullYear(); }       // Apr-Jun
    else { q = 2; year = d.getFullYear(); }                   // Jan-Mar
    const ord = ["1st", "2nd", "3rd", "4th"][q - 1];
    return `${ord} Quarter ${year}`;
  } catch {
    return "";
  }
}

